import script from "./UserPlatformsCell.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPlatformsCell.vue?vue&type=script&setup=true&lang=js"

import "./UserPlatformsCell.vue?vue&type=style&index=0&id=bfec078a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfec078a"]])

export default __exports__